export default __webpack_public_path__ + "static/media/phoneBook.311d808c.svg";